var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSupportHeadset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 16,
    height: 16,
    fill: "#00c4de"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4905",
    "data-name": "Group 4905",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M7.985,1.714a3.634,3.634,0,0,0-3.7,3.575v5a1.143,1.143,0,0,1-1.143,1.143H1.714A1.714,1.714,0,0,1,0,9.714V7.429A1.714,1.714,0,0,1,1.714,5.714h.857V5.269A5.349,5.349,0,0,1,8,0a5.349,5.349,0,0,1,5.429,5.269v.446h.857A1.714,1.714,0,0,1,16,7.429V9.714a1.714,1.714,0,0,1-1.714,1.714h-.857V12a3.143,3.143,0,0,1-2.789,3.123,1.714,1.714,0,0,1-1.5.877H7.429a1.714,1.714,0,0,1,0-3.429H9.143a1.711,1.711,0,0,1,1.463.821A1.429,1.429,0,0,0,11.714,12V5.288A3.634,3.634,0,0,0,7.985,1.714Z",
    transform: "translate(0 0)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupportHeadset);
export default __webpack_public_path__ + "static/media/icon_support_headset.4f76f92ba3eb06c587a12f063bf282e5.svg";
export { ForwardRef as ReactComponent };